
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto max-w-4xl px-6 py-8">
        <Button variant="ghost" onClick={() => navigate(-1)} className="mb-6">
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
        
        <h1 className="text-3xl font-bold mb-8">Terms and Conditions</h1>
        
        <div className="prose max-w-none">
          <p className="text-lg mb-6">These Terms and Conditions govern the purchase of hardware and image credits through our website and your access to the associated online Portal. By clicking "Accept" or completing a purchase, you agree to these terms.</p>

          <h2 className="text-xl font-semibold mt-6">1. DEFINITIONS</h2>
          <ul className="list-disc pl-6">
            <li><strong>"Equipment"</strong>: The camera hardware purchased by you.</li>
            <li><strong>"Image Credits"</strong>: Prepaid units determining the duration and scope of online access.</li>
            <li><strong>"Portal"</strong>: The online platform providing access to live and stored image data.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-6">2. ORDERING & PAYMENT</h2>
          <p><strong>2.1</strong> You agree to pay the full price as listed at checkout for the Equipment and Image Credits selected.</p>
          <p><strong>2.2</strong> All prices exclude applicable taxes, which you are responsible for.</p>
          <p><strong>2.3</strong> Payment is due at the time of order unless otherwise stated.</p>

          <h2 className="text-xl font-semibold mt-6">3. DELIVERY</h2>
          <p><strong>3.1</strong> Equipment will be delivered to the address provided at checkout.</p>
          <p><strong>3.2</strong> Risk in the Equipment passes to you upon delivery.</p>

          <h2 className="text-xl font-semibold mt-6">4. WARRANTY</h2>
          <p><strong>4.1</strong> Equipment is warranted for 12 months against manufacturing defects.</p>
          <p><strong>4.2</strong> Warranty does not apply to damage caused by misuse, neglect, or unauthorised repairs.</p>

          <h2 className="text-xl font-semibold mt-6">5. IMAGE CREDITS & PORTAL ACCESS</h2>
          <p><strong>5.1</strong> Portal access depends on having valid Image Credits.</p>
          <p><strong>5.2</strong> When Credits expire or are fully used, live image access and stored image retrieval will be suspended until new Credits are purchased.</p>
          <p><strong>5.3</strong> Different Credit bands determine how long and how often the camera remains active online.</p>

          <h2 className="text-xl font-semibold mt-6">6. USE OF THE PORTAL</h2>
          <p><strong>6.1</strong> You may only use the Portal for lawful purposes and in accordance with our acceptable use policy.</p>
          <p><strong>6.2</strong> You are responsible for safeguarding your login credentials.</p>

          <h2 className="text-xl font-semibold mt-6">7. DATA</h2>
          <p><strong>7.1</strong> You own the images and data generated by your Equipment.</p>
          <p><strong>7.2</strong> We may use anonymised or aggregated data for service improvement.</p>

          <h2 className="text-xl font-semibold mt-6">8. INTELLECTUAL PROPERTY</h2>
          <p><strong>8.1</strong> All intellectual property rights in the Equipment design, Portal software, website, documentation, trademarks, logos and any associated materials (the "Platform IP") are owned by us or our licensors.</p>
          <p><strong>8.2</strong> Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable, revocable licence to access and use the Portal and related software solely to view and retrieve your images and data.</p>
          <p><strong>8.3</strong> You shall not copy, modify, create derivative works of, reverse engineer, decompile, disassemble or otherwise attempt to derive the source code of any part of the Platform IP.</p>
          <p><strong>8.4</strong> All feedback, suggestions or ideas you provide ("Feedback") are non-confidential and we may use them without restriction; you hereby assign any rights in such Feedback to us.</p>

          <h2 className="text-xl font-semibold mt-6">9. LIABILITY</h2>
          <p><strong>9.1</strong> We are not liable for indirect or consequential losses.</p>
          <p><strong>9.2</strong> Our total liability is limited to the amount you paid in the 12 months preceding a claim.</p>

          <h2 className="text-xl font-semibold mt-6">10. GOVERNING LAW & DISPUTES</h2>
          <p><strong>10.1</strong> These terms are governed by the laws of the United Kingdom.</p>
          <p><strong>10.2</strong> Disputes will be resolved via mediation or arbitration in the United Kingdom.</p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
